<template>
    <router-view v-if="$route.name==='accountAdd' || $route.name==='accountEdit'"></router-view>
    <content-view
        class="accountList"
        v-else
    >
        <template slot="header">
            <reset-search
                class="pb32 pt16"
                ref="pa"
                :form.sync="form"
            >
                <table class="wh-form wh-form_full">
                    <tbody>
                    <tr>
                        <td width="70">手机号：</td>
                        <td>
                            <a-input
                                v-model="form.phone"
                                placeholder="请输入"
                            ></a-input>
                        </td>
                    </tr>
                    <tr>
                        <td
                            class="text-center"
                            colspan="6"
                        >
                            <a-button
                                @click="reset"
                                class="mr8"
                            >重 置
                            </a-button>
                            <a-button
                                type="primary"
                                @click="search"
                            >查 询
                            </a-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </reset-search>
        </template>
        <div class="bg-white pl32 pr32 pt32">
            <h4 class="orderBigList-title">{{$route.meta.name}}列表</h4>
            <div class="mt16">
                <a-button
                    type="primary"
                    class="mr8"
                    @click="addFleet"
                >新增
                </a-button>
            </div>
            <a-table
                :columns="columns"
                :dataSource="fleetList"
                :rowKey="record => record.id"
                bordered
                class="mt24"
                :pagination="pagination"
                @change="pageChange"
            >
                <template
                    slot="accountStatus"
                    slot-scope="text, record"
                >
                    {{text * 1 ?'正常':'禁用'}}
                </template>
                <template
                    slot="operation"
                    slot-scope="text, record"
                >
                    <a
                        @click="edit(text.id)"
                        class="btn btn_text"
                    >编辑</a>
                    <a-popconfirm
                        :title="text.status * 1 ? '确定禁用该账户？' : '确定启用该账户？'"
                        @confirm="confirm(text.id)"
                        @cancel="cancel"
                        okText="确认"
                        cancelText="取消"
                        okType="default"
                    >
                        <a
                            class="btn btn_text"
                            @click="centerId=text.id"
                        >{{ text.status * 1 ? '禁用' : '启用' }}</a>
                    </a-popconfirm>
                    
                </template>
            </a-table>
            
        </div>
    </content-view>
</template>
<script>
    export default {
        name: "orderMergeList",
        data() {
            return {
                form: {},
                columns: [
                    {
                        title: "姓名",
                        dataIndex: "username",
                        key: 'username'
                    },
                    {
                        title: "手机号",
                        dataIndex: "phone",
                        key: 'phone'
                    },
                    {
                        title: "区域权限",
                        dataIndex: "district",
                        key: 'district'
                    },
                    {
                        title: "账号状态",
                        dataIndex: "status",
                        scopedSlots: {customRender: "accountStatus"},
                        key: 'accountStatus'
                    },

                    {
                        title: "操作",
                        dataIndex: "",
                        scopedSlots: {customRender: "operation"},
                        key: 'operation'
                    }
                ],
                fleetList: [],
                pagination: {
                    //默认当前页
                    defaultCurrent: 1,
                    defaultPageSize: 10,
                    showTotal() {
                        return `共 ${this.total} 条数据`;
                    },
                    showSizeChanger: true,
                    total: 0
                },
                page: 1,
                limit: 10,
            };
        },
        components: {},
        computed: {},
        methods: {
            // 头部数据重置
            reset() {
                this.page = 1;
                this.limit = 10;
                this.$set(this.pagination, "current", 1);
                this.$set(this.pagination, "pageSize", 10);
                this.$refs.pa.reset();
                this.getList();
            },
            //查询
            search() {
                this.$set(this.pagination, "current", 1);
                this.$set(this.pagination, "pageSize", 10);
                this.page = 1;
                this.limit = 10;
                this.getList(true);
            },
            //获得账号列表
            //page:页 limit每页条数
            getList(status = false) {
                this.form.page = this.page;
                this.form.limit = this.limit;
                this.$api.account.accountList(this.form)
                    .then(res => {
                        this.pagination.total = res.total * 1;
                        this.fleetList = res.data.list;
                        status
                            ? this.$message.success("共查询到" + res.total + "条信息")
                            : "";
                    });
            },
            // 分页
            pageChange(pagination) {
                this.$set(this.pagination, "current", pagination.current);
                this.$set(this.pagination, "pageSize", pagination.pageSize);
                this.page = pagination.current;
                this.limit = pagination.pageSize;
                this.getList();
            },
            //新增按钮操作——跳转到新增页面
            addFleet() {
                this.$router.push({
                    name: "accountAdd"
                });
            },
            //编辑按钮操作——跳转到编辑页面
            edit(id) {
                this.$router.push({
                    name: "accountEdit",
                    query: {id: id}
                });
            },
            // 禁用启用
            confirm(id) {
                this.$api.account.accountSet({id: id}).then(res => {
                    if(res.data.error_no){
                        this.$message.error(res.msg);
                    }else{
                        this.$message.success(res.msg);
                        this.getList();
                    }
                })
            },
            cancel(){

            }
        },
        mounted() {
            
        },
        created() {
            this.getList();
        },
        watch: {
            $route(val) {
                if (val.name === "accountList") {
                    this.$set(this.pagination, "current", 1);
                    this.$set(this.pagination, "pageSize", 10);
                    this.page = 1;
                    this.limit = 10;
                    this.getList();
                }
            }
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss">
    .orderBigList {
        &-title {
            color: $title-color-black-85;
            @include pxAndLh(16);
            font-weight: bold;
        }
    }
</style>
